import {
  QAlert,
  QBox,
  QButton,
  QModal,
  QModalActions,
  QModalBody,
  QModalHeader,
  QStack,
  QText,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { EmbeddedDocument } from '../hooks/useEmbeddedDocuments';

type EmbedWarningModalProps = {
  isOpen: boolean;
  handleCreate: () => void;
  handleClose: () => void;
  embeddedDocuments: EmbeddedDocument[];
};

export const EmbedWarningModal = ({
  isOpen,
  handleCreate,
  handleClose,
  embeddedDocuments,
}: EmbedWarningModalProps) => {
  const { t } = useTranslation();

  return (
    <QModal
      size="xl"
      isOpen={isOpen}
      onClose={handleClose}
      data-cy={'embed-warning-modal'}
    >
      <QModalHeader>
        <QText>{t('createNewDraft.embedWarningHeader')}</QText>
      </QModalHeader>
      <QModalBody>
        <QStack spacing={2}>
          <QAlert
            title={t('createNewDraft.embedWarningTitle', {
              count: embeddedDocuments.length,
            })}
            description={t('createNewDraft.embedWarningDescription')}
            status="warning"
          />
          <QStack maxHeight="450px" style={{ overflowY: 'auto' }} py={2}>
            <QText mt={2}> {t('createNewDraft.embedWarningList')} </QText>
            <QStack>
              {embeddedDocuments.map((doc: EmbeddedDocument) => (
                <QBox pl={6} key={doc.identifiers.id}>
                  <li>
                    <QText>{doc.identifiers.code}</QText>
                  </li>
                </QBox>
              ))}
            </QStack>
          </QStack>
        </QStack>
      </QModalBody>
      <QModalActions>
        <QButton
          data-cy="cancel-create-draft-button"
          variant="outline"
          onClick={handleClose}
        >
          {t('buttons.cancel')}
        </QButton>
        <QButton data-cy="confirm-create-draft-button" onClick={handleCreate}>
          {t('buttons.createDraft')}
        </QButton>
      </QModalActions>
    </QModal>
  );
};
